'use strict';
import * as $j_app$002e$002dClient$002dMain from "./app.-Client-Main.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
$j_app$002e$002dClient$002dMain.$s_Lapp_ClientMain__main__AT__V(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([]));
//# sourceMappingURL=main.js.map
